import {ExError,ErrorType} from './error';

export class UriError implements ExError{        
    name:string;
    message:string; 
    url:string; 
	constructor(name:string,message:string,url:string) {		
		this.name = name;
        this.message = message;                
        this.url = url;
	}
}



// WEBPACK FOOTER //
// ./src/app/error/uri-error.ts